exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#by-the-foot-section .expansionHeader {\n  background-color: lightgrey !important; }\n  #by-the-foot-section .expansionHeader mat-panel-title, #by-the-foot-section .expansionHeader mat-panel-description {\n    font-size: 16px;\n    font-weight: 500; }\n  #by-the-foot-section .tableHead {\n  font-size: 16px;\n  font-weight: 600; }\n  #by-the-foot-section .costTable {\n  border-collapse: collapse;\n  border-spacing: 0;\n  table-layout: fixed; }\n  #by-the-foot-section .costTable thead tr td {\n    font-size: 16px;\n    font-weight: 600; }\n  #by-the-foot-section .costTable td {\n    padding: 5px;\n    border: 1px solid;\n    height: 0px; }\n  #by-the-foot-section .closeBtn {\n  left: 90%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/common/by-the-foot-section/by-the-foot-section.component.scss
// module id = ../../../../../src/app/main/content/apps/common/by-the-foot-section/by-the-foot-section.component.scss
// module chunks = main